import React from 'react';
import { Gavel } from 'lucide-react';
import { LegalLayout, LegalSection } from '../components/LegalLayout';

export default function Terms() {
  return (
    <LegalLayout
      testid="terms-page"
      eyebrow="Terms & Conditions"
      icon={Gavel}
      title="Terms & Conditions"
      intro="Lunar Legacies conducts online space-memorabilia auctions. The terms below reflect our current published auction terms. Specific details can vary by individual sale, so the terms shown on the active auction listing always govern that sale."
      seo={{
        path: '/terms',
        title: 'Terms & Conditions | Lunar Legacies',
        description: 'Lunar Legacies auction terms and conditions — buyer\u2019s premium, payment methods, bid increments, and shipping for our space memorabilia auctions.',
      }}
    >
      <LegalSection heading="Buyer's Premium" testid="terms-premium">
        <p>A 24% buyer's premium is added to the hammer price of each lot.</p>
      </LegalSection>

      <LegalSection heading="Payment Methods" testid="terms-payment">
        <p>We accept Check, Money Order, Zelle, Venmo, Wire Transfer, or Credit Card.</p>
        <ul className="list-disc pl-5 space-y-1.5">
          <li>A 3% charge is added to each credit card purchase.</li>
          <li>
            <span className="text-white/90">PayPal:</span> Buyers outside the US may use PayPal only via the Friends &amp; Family
            option. For U.S. buyers, please add 3% to your total if you pay through PayPal.
          </li>
          <li>Check, Money Order, or Venmo is encouraged — no fees and faster shipping.</li>
        </ul>
      </LegalSection>

      <LegalSection heading="Bid Increments" testid="terms-increments">
        <p>Your bid must adhere to the bid increment schedule:</p>
        <div className="mt-2 border border-white/10 divide-y divide-white/10 text-xs md:text-sm font-mono-luxury text-white/80">
          {[
            ['$0 – $99', '$10'],
            ['$99 – $299', '$20'],
            ['$299 – $499', '$25'],
            ['$499 – $999', '$50'],
            ['$999 – $2,999', '$100'],
            ['$2,999 and above', '$200'],
          ].map(([range, inc]) => (
            <div key={range} className="flex justify-between px-4 py-2.5">
              <span>{range}</span>
              <span className="text-luxury-gold">{inc}</span>
            </div>
          ))}
        </div>
      </LegalSection>

      <LegalSection heading="Shipping" testid="terms-shipping">
        <p>
          Shipping is estimated as close to actual cost as possible and added to your invoice. Shipping is available via USPS,
          UPS, or FedEx.
        </p>
      </LegalSection>

      <LegalSection heading="Invoicing" testid="terms-invoicing">
        <p>Auctions are online-only. Winning bidders receive an invoice after the sale.</p>
      </LegalSection>

      <LegalSection heading="Third-Party Auction Platforms" testid="terms-thirdparty">
        <p>
          Lunar Legacies auctions are often hosted on third-party platforms (such as Invaluable and others). When you bid
          through one of these platforms, that platform's own terms, registration requirements, and fees may also apply in
          addition to the terms above.
        </p>
      </LegalSection>

      <LegalSection heading="Contact" testid="terms-contact">
        <p>
          Questions about a lot or these terms?{' '}
          <a href="tel:3218483337" className="text-luxury-goldLight hover:text-luxury-gold transition-colors">321-848-3337</a>{' '}
          ·{' '}
          <a href="mailto:lunarlegacies@gmail.com" className="text-luxury-goldLight hover:text-luxury-gold transition-colors">lunarlegacies@gmail.com</a>
        </p>
      </LegalSection>
    </LegalLayout>
  );
}
